
import React from "react"
import PropTypes from "prop-types"
import { Modal } from "antd"
import Form from "./Form"
import { UnsavedChangesModal } from "ui/UnsavedChangesModal"

function FormAntdModal({visible,setVisible,expenseId,expense,record,...props}) {
  const [isDirty, setIsDirty] = React.useState(false)
  const [showUnsaved, setShowUnsaved] = React.useState(false)

  const handleClose = () => {
    setVisible(false)
    if (props.onClose) props.onClose()
  }

  const handleCancel = () => {
    if (isDirty) {
      setShowUnsaved(true)
    } else {
      handleClose()
    }
  }

  return (
    <>
      <Modal
        open={visible}
        onCancel={handleCancel}
        footer={null}
        width={800}
        destroyOnClose
        centered
        maskClosable={false}
      >
        <Form {...props} closeHandler={handleCancel} expenseId={expenseId} expense={expense} setVisible={setVisible} onChanged={setIsDirty} />
      </Modal>
      <UnsavedChangesModal
        open={showUnsaved}
        onKeepEditing={() => setShowUnsaved(false)}
        onDiscard={() => {
          setShowUnsaved(false)
          handleClose()
        }}
      />
    </>
  )
}

FormAntdModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  expenseId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  expense: PropTypes.object,
  record: PropTypes.object,
  onClose: PropTypes.func,
}

export default FormAntdModal
